import { Component } from '@angular/core';

import { NavParams, ViewController } from 'ionic-angular';

import { ConferenceData } from '../../providers/conference-data';

declare var dataLayer: Array<any>;

@Component({
  selector: 'page-schedule-filter',
  templateUrl: 'schedule-filter.html'
})
export class ScheduleFilterPage {
  tracks: Array<{name: string, isChecked: boolean}> = [];

  constructor(
    public confData: ConferenceData,
    public navParams: NavParams,
    public viewCtrl: ViewController
  ) {
    // passed in array of track names that should be excluded (unchecked)
    let excludedTrackNames = this.navParams.data;

    this.confData.getTracks().subscribe((trackNames: string[]) => {

      trackNames.forEach(trackName => {
        this.tracks.push({
          name: trackName,
          isChecked: (excludedTrackNames.indexOf(trackName) === -1)
        });
      });

    });
  }

  resetFilters() {
    // reset all of the toggles to be checked
    this.tracks.forEach(track => {
      track.isChecked = true;
    });


    dataLayer.push({
      'appEventCategory': 'schedule-filter',
      'appEventAction': 'resetFilters',
      'appEventLabel': 'resetFilters button'
    });
    dataLayer.push({'event': 'appEvent'});

  }

  applyFilters() {
    // Pass back a new array of track names to exclude
    let excludedTrackNames = this.tracks.filter(c => !c.isChecked).map(c => c.name);
    this.dismiss(excludedTrackNames);


    dataLayer.push({
      'appEventCategory': 'schedule-filter',
      'appEventAction': 'applyFilters',
      'appEventLabel': 'applyFilters button'
    });
    dataLayer.push({'event': 'appEvent'});

  }

  dismiss(data?: any) {
    // using the injected ViewController this page
    // can "dismiss" itself and pass back data
    this.viewCtrl.dismiss(data);

    dataLayer.push({
      'appEventCategory': 'schedule-filter',
      'appEventAction': 'dismiss',
      'appEventLabel': 'dismiss button'
    });
    dataLayer.push({'event': 'appEvent'});
  }

  ionViewDidLoad() {
    dataLayer.push({
      'screenPath': 'schedule-filter',
      'screenName': 'ScheduleFilterPage'
    });
    dataLayer.push({'event': 'appScreenView'});
  }
}



// WEBPACK FOOTER //
// ./src/pages/schedule-filter/schedule-filter.ts